/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./dialog.vue?vue&type=template&id=65337f8e&scoped=true&"
import script from "./dialog.vue?vue&type=script&lang=ts&"
export * from "./dialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65337f8e",
  null
  
)

export default component.exports